import { SECTORS } from './index';
import { Action } from '../action';
import { SectorInfo } from '@shared/core';

export class SectorsStartServiceAction implements Action {
	readonly type = SECTORS.START_SERVICE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SectorsStopServiceAction implements Action {
	readonly type = SECTORS.STOP_SERVICE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SectorsHydrateAction implements Action {
	readonly type = SECTORS.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SectorsHydrateSuccessAction implements Action {
	readonly type = SECTORS.HYDRATE_SUCCESS;
	constructor(
		public payload: SectorInfo[],
		public correlationId?: number
	) {}
}

export class SectorsHydrateFailureAction implements Action {
	readonly type = SECTORS.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
